import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

/**
 * Static "thank you" page Gumroad redirects to after a successful purchase.
 *
 * To activate: in Gumroad, edit the consultation product → Settings →
 * "Redirect customers to a website after purchase" → paste:
 *   https://nextxus.help/consultation/success
 *
 * Gumroad may append ?sale_id=... — we display it for the customer's record
 * but do NOT poll any status endpoint (Gumroad already emailed the receipt).
 */
export default function ConsultationSuccess() {
  const [params] = useSearchParams();
  const saleId = params.get('sale_id');

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div
        data-testid="consultation-success-card"
        className="max-w-xl w-full bg-gradient-to-br from-gray-900 via-gray-900 to-amber-950/40 border border-amber-500/40 rounded-2xl p-10 shadow-2xl shadow-amber-900/30"
      >
        <div className="mb-6">
          <span className="text-xs font-mono text-amber-300 bg-amber-500/10 border border-amber-500/30 px-3 py-1 rounded-full">
            [DIR-073] Spark and Lens Covenant
          </span>
        </div>
        <h1 className="text-3xl font-bold text-amber-400 mb-4">Welcome to the Cathedral</h1>
        <p className="text-gray-200 mb-2">
          Your $3 consultation is confirmed. The Architect will follow up by email within 24 hours
          to schedule your 30 minutes.
        </p>
        <p className="text-sm text-gray-400 mb-6">
          To save a round trip, please reply to Gumroad's receipt email with{' '}
          <strong className="text-amber-300">two or three time windows that work for you</strong>.
        </p>

        {saleId && (
          <div
            data-testid="consultation-sale-id"
            className="text-xs text-gray-500 font-mono mb-6 break-all"
          >
            Sale ID: {saleId}
          </div>
        )}

        <div className="border-t border-gray-800 pt-6 space-y-3">
          <p className="text-sm text-gray-300">
            While you wait, you may want to read the operating law we build by:
          </p>
          <Link
            to="/charter"
            data-testid="consultation-charter-link"
            className="inline-flex items-center gap-2 text-amber-300 hover:text-amber-200"
          >
            → The 112 Sacred Directives · Code Book Vol 1
          </Link>
        </div>

        <div className="mt-8">
          <Link
            to="/"
            data-testid="consultation-return-home"
            className="inline-block px-5 py-2 rounded-full bg-amber-400 text-black font-semibold hover:bg-amber-300 transition-colors"
          >
            Return to HumanCodex University
          </Link>
        </div>
      </div>
    </div>
  );
}
